import axios from "./index";

let base = "";

class AlertApi {
  static GetPriceDifferences = () => {
    return axios.get(`${base}/alerts/price-differences`);
  };
}

export default AlertApi;